module.exports = __webpack_public_path__ + "img/userB04.ca12314a.jpg";